import {t} from 'i18next';
import {useCallback, useEffect, useState} from 'react';
import {CustomFieldSection} from './CustomFieldSection';
import {ITag} from './DraggableTag';
import {DraggableTagList, IDraggableTagListProps} from './DraggableTagList';

interface IFieldCategoryTagsProps extends IDraggableTagListProps {
  onSaveChanges: (tags: ITag[]) => void;
  canEditTags?: boolean;
}

const FieldCategoryTags: React.FC<IFieldCategoryTagsProps> = ({
  onSaveChanges,
  canEditTags,
  tags: initialTags,
  ...restProps
}) => {
  const [tags, setTags] = useState<ITag[]>(initialTags);

  useEffect(() => {
    setTags(initialTags);
  }, [initialTags]);

  const handleReorder = useCallback((reorderTags: ITag[]) => {
    setTags(reorderTags);
  }, []);

  return (
    <CustomFieldSection title={t('fieldManagement.customField.tags')}>
      <DraggableTagList
        tags={tags}
        handleReorder={handleReorder}
        onSaveChanges={onSaveChanges}
        canEditTags={canEditTags}  
        {...restProps}
      />
    </CustomFieldSection>
  );
};

export {FieldCategoryTags};
